var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaldives(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17389 6.26086H19.8261V17.7391H4.17389V6.26086Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9325 15.3913C12.0596 15.3913 10.5412 13.8729 10.5412 12C10.5412 10.127 12.0596 8.60867 13.9325 8.60867C14.5165 8.60867 15.066 8.75633 15.5457 9.0163C14.7931 8.28032 13.764 7.82605 12.6282 7.82605C10.3231 7.82605 8.45428 9.69477 8.45428 11.9999C8.45428 14.3051 10.3231 16.1738 12.6282 16.1738C13.764 16.1738 14.7932 15.7196 15.5457 14.9836C15.066 15.2436 14.5165 15.3913 13.9325 15.3913Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaldives);
export default __webpack_public_path__ + "static/media/maldives.4986b09f2269732ee38afc959ab71ce0.svg";
export { ForwardRef as ReactComponent };